import { __ } from '@wordpress/i18n';
import type { Option } from '@/admin/api/activities';
import { createOptionsField } from './options-field';

declare module '@tiptap/core' {
	interface Commands<ReturnType> {
		multipleChoice: {
			insertMultipleChoice: (attrs?: {
				label?: string;
				required?: boolean;
				options?: Option[];
			}) => ReturnType;
		};
	}
}

export const MultipleChoice = createOptionsField({
	name: 'multipleChoice',
	dataType: 'multiple-choice',
	typeLabel: __('Single Choice', 'allcoach'),
	commandName: 'insertMultipleChoice',
	isCheckbox: false,
});
